/* esm.sh - react-router@8.4.0/dist/production/lib/dom/ssr/markup */
var t={"&":"\\u0026",">":"\\u003e","<":"\\u003c","\u2028":"\\u2028","\u2029":"\\u2029"},c=/[&><\u2028\u2029]/g;function r(e){return e.replace(c,u=>t[u])}function p(e){return e.replace(/&/g,"&amp;").replace(/"/g,"&quot;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}export{p as escapeAttribute,r as escapeHtml};
/*! Bundled license information:

react-router/dist/production/lib/dom/ssr/markup.js:
  (**
   * react-router v8.4.0
   *
   * Copyright (c) Remix Software Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   *)
*/
//# sourceMappingURL=markup.mjs.map